import { useState, useEffect } from "react";
// Imports MUI Components
import {
  Box,
  Typography,
  Button,
  CardContent,
  Stack,
  Tooltip
} from "@mui/material"
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip'

import Icon from "../../atoms/icon/Icon";
import Text from "../../atoms/text/Text";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 200,
    padding: "10px",
    fontSize: "12px"
  },
});

const Widget = ({ 
  label,
  content,
  src,
  weight,
  tip,
  defaults,
  newPatients,
  returningPatients,
  widget,
  fullHeight = false,
}) => {

  const [iconSrc, setIconSrc] = useState(require("../../../../assets/icons/help.png"));

  return (
    <div style={{ height: fullHeight ? "100%" : "auto", display: "flex" }}>
      <Box 
        border="1px solid rgba(89, 84, 74, 0.8)"
        backgroundColor="#fefefe"
        sx={{
          borderRadius: "16px",
          // allow the widget to fill parent when requested
          height: fullHeight ? "100%" : "auto",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}>

        <CardContent
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            // only force full height when requested
            height: fullHeight ? "100%" : "auto",
            flex: fullHeight ? 1 : "none",
          }}>



                              <Stack 
                                direction="row"
                                sx={{
                                  width: "100%",
                                  justifyContent: "space-between",
                                  alignContent: "center",
                                  alignItems: "center",
                                  gap: 6,
                                  // backgroundColor: "mediumaquamarine",
                                  textAlign: "center",
                                  justifyItems: "center"
                              }}>   

                                <Stack
                                direction="row"
                                alignItems="center">
                                <Box
                                  sx={{
                                    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.25)",
                                    borderRadius: "10px"
                                  }}>
                                  
                                  <Icon
                                    src={src}
                                    size="small"/>

                                </Box>
                          <Text
                            text={label}
                            variant={weight === "bold" ? "" : "h3HeaderBold"}
                            />
                            </Stack>

                              <CustomWidthTooltip 
                                title={tip}
                                placement="top-end"
                                arrow
                                sx={{
                                  maxWidth: 200
                                }}
                              >
                                <Box
                                  onMouseEnter={() => setIconSrc(require("../../../../assets/icons/help_dark.png"))}
                                  onMouseLeave={() => setIconSrc(require("../../../../assets/icons/help.png"))}
                                  sx={{
                                    width: "40px",
                                    height: "40px"
                                  }}
                                >
                                    
                                  <Icon
                                    src={iconSrc}
                                    size="small"/>

                                </Box>
                              </CustomWidthTooltip >




                            </Stack> 

                         {defaults && (
                            // Render primitive (string/number) inside Typography,
                            // render React node (charts/complex JSX) directly so layout works.
                            typeof content === "string" || typeof content === "number" ? (
                              <Box sx={{ display: "flex", alignItems: "flex-start", minHeight: "60px" }}>
                                <Typography
                                  variant="h2"
                                  sx={{ padding: "15px 10px", fontSize: "24px", lineHeight: 1 }}
                                >
                                  {content}
                                </Typography>
                              </Box>
                            ) : (
                              // allow complex content (charts) to size itself; if fullHeight is true,
                              // parent will provide the height so ResponsiveContainer works.
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                {content}
                              </Box>
                            )
                          )}

                        {widget === "revenuePatients" && (
                          <>
{newPatients || returningPatients ? (
                                  <Box
                                    sx={{
                                      borderLeft: "2px solid black",
                                      borderRight: "2px solid black",
                                    }}>
                                      <Stack
                                        direction="row"
                                        width="100%">

                                      <Stack
                                        direction="column"
                                        sx={{
                                          width: newPatients / (returningPatients +  newPatients),
                                          borderRight: "2px solid black",
                                          padding: "0 8px",
                                          overflowX: "hidden", 
                                          transition: "width 0.5s"
                                        }}>
                                  <Typography
                                  variant="h2"
                                  sx={{
                                    padding: "2px 0",
                                    fontSize: "17px",
                                    // backgroundColor: "aqua",
                                  }}>{newPatients}
                                </Typography>
                                  <Typography
                                  variant="h2"
                                  sx={{
                                    padding: "2px 0",
                                    fontSize: "17px",
                                    fontWeight: 100
                                    // backgroundColor: "aqua",
                                  }}>New
                                </Typography>
                                <Box
                                    sx={{
                                      height: "15px",
                                      backgroundColor: "#C5A572"
                                    }}></Box>
                                </Stack>

                                      <Stack
                                        direction="column"
                                        sx={{
                                          width: returningPatients / (returningPatients +  newPatients),
                                          padding: "0 8px",
                                          overflowX: "hidden", 
                                          transition: "width 0.5s"
                                        }}>
                                  <Typography
                                  variant="h2"
                                  sx={{
                                    padding: "2px 0",
                                    fontSize: "17px",
                                  }}>{returningPatients}
                                </Typography>
                                  <Typography
                                  variant="h2"
                                  sx={{
                                    padding: "2px 0",
                                    fontSize: "17px",
                                    fontWeight: 100
                                  }}>Returning
                                </Typography>
                                <Box
                                    sx={{
                                      height: "15px",
                                      backgroundColor: "#C5A572"
                                    }}></Box>
                                </Stack>
                                      </Stack>
                                  </Box>
                                ) : (
                                  <>
                                  <Typography
                                  variant="h2"
                                  sx={{
                                    padding: "15px 10px",
                                    fontSize: "24px",
                                  }}>0
                                </Typography>
                                  </>
                                )}
</>
                        )}  

                        {widget === "dailyBooking" && (
                          <>

                          </>
                        )}
                          

                        </CardContent>
                        
                      </Box>
                      

    </div>
  );
};

export default Widget; 